import React from 'react';
import Lookup from 'src/componentes/select2';

const LinguaLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/LinguaLookup" {...rest} />;

export default LinguaLookup;
